import {
  MainBlock,
  SmthBanner,
} from "../../../shared/pages/opencallsPage/GetCompetitionItem/style";
import { useTranslation } from "react-i18next";
import { FC } from "react";
import { PopUpMenu } from "shared/pages/opencallsPage/GetCompetitionItem/PopUpMenu";
import { FlexBox, ResizedImage, useIsMobile } from "@brg/ui";
import {
  useMemo,
  useEffect,
  useState,
} from "react";
import { CompetitionAPI, Competition, API } from "@brg/api";
import { useParams } from "react-router-dom";
import { ProjectsButchController } from "../../../core/controllers/ProjectsButchController";

import { ProfileRole, bProfile } from "@brg/auth";
import { SortingTypeIndex } from "shared/constants/sortingType";
import { useProfile } from "core/auth";
import {
  useEncodedStateFilter,
} from "shared/components/Filters";
import { ItemType } from "shared/constants/itemType";
import useQueryState from "../../../shared/hooks/useQueryState";
import {
  COMPETITIONS_WITH_OPEN_PROJECTS,
} from "../../../shared/pages/opencallsPage/GetCompetitionItem/GetCompetitionItem";
import { HsePolicies } from "shared/constants/HsePolicies";

const PROJECT_TAB_SIGN = "3";

export const CompetitionProjectsPage: FC<{
  openLikeTab?: boolean;
  mobileSorting: number;
  isDarkTheme?: boolean;
  onMobileSortingChange?: (s: SortingTypeIndex) => void;
  externalId?: string;
}> = ({
  openLikeTab,
  mobileSorting,
  externalId,
}) => {
  const { i18n } = useTranslation();
  const isMobile = useIsMobile();
  const [selectedTab, setSelectedTab] = useState("projects");
  const { id = externalId } = useParams<{ id: string }>();

  const { sorting, setSorting } = useEncodedStateFilter();

  const [time, setTime] = useState(Date.now());

  const [competition, setCompetition] = useState<Competition>();
  const [visiblePopUp, setIsVisiblePopUp] = useState<boolean>(false);
  const [banMobileTabs, setBanMobileTabs] = useState<string[]>([""]);
  const profile = useProfile();
  const [{ unrated }, setQueryParams] = useQueryState();

  const isModer = useMemo(() => {
    if (profile) {
      const hasPolicyCompetitionModer =
        profile.rolesList &&
        Array.isArray(profile.rolesList) &&
        new ProfileRole(HsePolicies.access_competitions).containsIn(
          profile.rolesList
        );

      return bProfile.isModer(profile) || hasPolicyCompetitionModer;
    }
  }, [profile]);

  const filterSorting = useMemo(
    () => (mobileSorting == 1 ? 22 : mobileSorting),
    [mobileSorting]
  );

  const isCompetitionModer = useMemo(
    () => profile && competition?.moderatorID?.includes(profile?.designerId),
    [competition, profile]
  );

  const isJury = useMemo(
    () =>
      (profile &&
        competition &&
        competition?.juryID?.includes(profile?.designerId)) ||
      false,
    [competition, profile, id]
  );

  const isBriefModer = useMemo(
    () =>
      (profile &&
        profile.rolesList &&
        Array.isArray(profile.rolesList) &&
        new ProfileRole(HsePolicies.access_brief_competitions).containsIn(
          profile.rolesList
        )) ||
      undefined,
    [profile]
  );

  const isBriefCompetition = useMemo(
    () => !!competition?.isBriefCompetition,
    [competition]
  );

  const canViewCompetitionPoint = useMemo(
    () => isJury || isModer || isCompetitionModer,
    [isJury, isCompetitionModer, isModer]
  );

  const showProjectTabForAll = useMemo(
    () =>
      //@ts-ignore
      competition?.infoTabs?.find((tab) => tab?.tabId === PROJECT_TAB_SIGN)
        ?.enable,
    [competition]
  );

  const showProjects = useMemo(
    () =>
      showProjectTabForAll ||
      isModer ||
      (isBriefModer && isBriefCompetition) ||
      isCompetitionModer ||
      isJury ||
      COMPETITIONS_WITH_OPEN_PROJECTS.includes(
        competition?.competitionId || ""
      ),
    [
      competition,
      isModer,
      isCompetitionModer,
      showProjectTabForAll,
      isJury,
      isBriefModer,
      isBriefCompetition,
    ]
  );

  const filterOpt = useMemo(() => {
    return {
      isContextIgnored: true,
      competitionIds: [id],
      projectFilter: filterSorting,
      projectStatus: [1],
      limit: 40,
      initJuryVote: isJury,
      onlyWithoutJuryVotes: !!isJury && !!unrated,
    };
  }, [filterSorting, id, isJury, unrated]);

  useEffect(() => {
    if (mobileSorting) {
      setTime(Date.now());
    }
  }, [mobileSorting]);

  useEffect(() => {
    if (isMobile) {
      setTime(Date.now());
    }
  }, [isMobile, sorting]);

  useEffect(() => {
    if (id) {
      CompetitionAPI.Get({ idCompetition: id })
        .then((r) => r.json())
        .then((v) => API.toLang<Competition>(v, i18n.language))
        .then((v) => {
          setCompetition(v);
        });
    }
  }, [id, i18n]);

  useEffect(() => {
    if (
      competition &&
      competition?.juryID &&
      competition?.juryID.length === 0
    ) {
      setBanMobileTabs(["jury"]);
    } else {
      setBanMobileTabs([""]);
    }
  }, [competition]);

  //хардкод для для конкурса
  if (
    competition &&
    competition?.competitionId === "43bd8964119e473c9944c1ef43aee6f2"
  ) {
    window.open(process.env.REACT_APP_URL_DEZIIIGN_BOOKS, "_SELF");
  }

  const TabComponent = useMemo(
    () => (
      <MainBlock style={{ marginTop: "0", padding: 0 }}>
        <FlexBox align="center" offsetTop={24} offsetTopMobile={1}>
          <ProjectsButchController
            //@ts-ignore
            filter={filterOpt}
            date={time}
            withoutRepost
            isInfinityNeed={false}
            disableFilterCheck
            showCompetitionPoint={canViewCompetitionPoint}
            showCompetitionJuryPoint={isJury}
            currentCompetitionId={id}
            itemType={ItemType.competition}
            competition={competition}
          />
        </FlexBox>
      </MainBlock>
    ),
    [filterOpt, isJury, id, time, canViewCompetitionPoint, competition]
  );

  if (!showProjects) {
    return null;
  }

  if (openLikeTab) {
    return TabComponent;
  }

  return (
    <>
      <PopUpMenu
        key="menu-popup-deziiign"
        isVisible={visiblePopUp}
        onClose={() => setIsVisiblePopUp(false)}
        activeTab={selectedTab}
        showOnlyTabs
        banTabs={banMobileTabs}
      />
      <MainBlock style={{ marginTop: "64px" }}>
        <SmthBanner isHideMarginBottom isMobile={isMobile}>
          <ResizedImage files={competition?.titleImages} />
        </SmthBanner>
        <FlexBox align="center" offsetTop={40}>
          <ProjectsButchController
            //@ts-ignore
            filter={filterOpt}
            withoutRepost
            //onProjectsLoaded={setProjects}
            showCompetitionPoint={canViewCompetitionPoint}
            showCompetitionJuryPoint={isJury}
            currentCompetitionId={id}
            date={time}
            isInfinityNeed={false}
            externalPageParam
            competition={competition}
          />
        </FlexBox>
      </MainBlock>
    </>
  );
};
import {
  MainBlock,
  SmthBanner,
} from "../../../shared/pages/opencallsPage/GetCompetitionItem/style";
import { useTranslation } from "react-i18next";
import { FC } from "react";
import { PopUpMenu } from "shared/pages/opencallsPage/GetCompetitionItem/PopUpMenu";
import { FlexBox, ResizedImage, useIsMobile } from "@brg/ui";
import {
  useMemo,
  useEffect,
  useState,
} from "react";
import { CompetitionAPI, Competition, API } from "@brg/api";
import { useParams } from "react-router-dom";
import { ProjectsButchController } from "../../../core/controllers/ProjectsButchController";

import { ProfileRole, bProfile } from "@brg/auth";
import { SortingTypeIndex } from "shared/constants/sortingType";
import { useProfile } from "core/auth";
import {
  useEncodedStateFilter,
} from "shared/components/Filters";
import { ItemType } from "shared/constants/itemType";
import useQueryState from "../../../shared/hooks/useQueryState";
import {
  COMPETITIONS_WITH_OPEN_PROJECTS,
} from "../../../shared/pages/opencallsPage/GetCompetitionItem/GetCompetitionItem";
import { HsePolicies } from "shared/constants/HsePolicies";

const PROJECT_TAB_SIGN = "3";

export const CompetitionProjectsPage: FC<{
  openLikeTab?: boolean;
  mobileSorting: number;
  isDarkTheme?: boolean;
  onMobileSortingChange?: (s: SortingTypeIndex) => void;
  externalId?: string;
}> = ({
  openLikeTab,
  mobileSorting,
  externalId,
}) => {
  const { i18n } = useTranslation();
  const isMobile = useIsMobile();
  const [selectedTab, setSelectedTab] = useState("projects");
  const { id = externalId } = useParams<{ id: string }>();

  const { sorting, setSorting } = useEncodedStateFilter();

  const [time, setTime] = useState(Date.now());

  const [competition, setCompetition] = useState<Competition>();
  const [visiblePopUp, setIsVisiblePopUp] = useState<boolean>(false);
  const [banMobileTabs, setBanMobileTabs] = useState<string[]>([""]);
  const profile = useProfile();
  const [{ unrated }, setQueryParams] = useQueryState();

  const isModer = useMemo(() => {
    if (profile) {
      const hasPolicyCompetitionModer =
        profile.rolesList &&
        Array.isArray(profile.rolesList) &&
        new ProfileRole(HsePolicies.access_competitions).containsIn(
          profile.rolesList
        );

      return bProfile.isModer(profile) || hasPolicyCompetitionModer;
    }
  }, [profile]);

  const filterSorting = useMemo(
    () => (mobileSorting == 1 ? 22 : mobileSorting),
    [mobileSorting]
  );

  const isCompetitionModer = useMemo(
    () => profile && competition?.moderatorID?.includes(profile?.designerId),
    [competition, profile]
  );

  const isJury = useMemo(
    () =>
      (profile &&
        competition &&
        competition?.juryID?.includes(profile?.designerId)) ||
      false,
    [competition, profile, id]
  );

  const isBriefModer = useMemo(
    () =>
      (profile &&
        profile.rolesList &&
        Array.isArray(profile.rolesList) &&
        new ProfileRole(HsePolicies.access_brief_competitions).containsIn(
          profile.rolesList
        )) ||
      undefined,
    [profile]
  );

  const isBriefCompetition = useMemo(
    () => !!competition?.isBriefCompetition,
    [competition]
  );

  const canViewCompetitionPoint = useMemo(
    () => isJury || isModer || isCompetitionModer,
    [isJury, isCompetitionModer, isModer]
  );

  const showProjectTabForAll = useMemo(
    () =>
      //@ts-ignore
      competition?.infoTabs?.find((tab) => tab?.tabId === PROJECT_TAB_SIGN)
        ?.enable,
    [competition]
  );

  const showProjects = useMemo(
    () =>
      showProjectTabForAll ||
      isModer ||
      (isBriefModer && isBriefCompetition) ||
      isCompetitionModer ||
      isJury ||
      COMPETITIONS_WITH_OPEN_PROJECTS.includes(
        competition?.competitionId || ""
      ),
    [
      competition,
      isModer,
      isCompetitionModer,
      showProjectTabForAll,
      isJury,
      isBriefModer,
      isBriefCompetition,
    ]
  );

  const filterOpt = useMemo(() => {
    return {
      isContextIgnored: true,
      competitionIds: [id],
      projectFilter: filterSorting,
      projectStatus: [1],
      limit: 40,
      initJuryVote: isJury,
      onlyWithoutJuryVotes: !!isJury && !!unrated,
    };
  }, [filterSorting, id, isJury, unrated]);

  useEffect(() => {
    if (mobileSorting) {
      setTime(Date.now());
    }
  }, [mobileSorting]);

  useEffect(() => {
    if (isMobile) {
      setTime(Date.now());
    }
  }, [isMobile, sorting]);

  useEffect(() => {
    if (id) {
      CompetitionAPI.Get({ idCompetition: id })
        .then((r) => r.json())
        .then((v) => API.toLang<Competition>(v, i18n.language))
        .then((v) => {
          setCompetition(v);
        });
    }
  }, [id, i18n]);

  useEffect(() => {
    if (
      competition &&
      competition?.juryID &&
      competition?.juryID.length === 0
    ) {
      setBanMobileTabs(["jury"]);
    } else {
      setBanMobileTabs([""]);
    }
  }, [competition]);

  //хардкод для для конкурса
  if (
    competition &&
    competition?.competitionId === "43bd8964119e473c9944c1ef43aee6f2"
  ) {
    window.open(process.env.REACT_APP_URL_DEZIIIGN_BOOKS, "_SELF");
  }

  const TabComponent = useMemo(
    () => (
      <MainBlock style={{ marginTop: "0", padding: 0 }}>
        <FlexBox align="center" offsetTop={24} offsetTopMobile={1}>
          <ProjectsButchController
            //@ts-ignore
            filter={filterOpt}
            date={time}
            withoutRepost
            isInfinityNeed={false}
            disableFilterCheck
            showCompetitionPoint={canViewCompetitionPoint}
            showCompetitionJuryPoint={isJury}
            currentCompetitionId={id}
            itemType={ItemType.competition}
            competition={competition}
          />
        </FlexBox>
      </MainBlock>
    ),
    [filterOpt, isJury, id, time, canViewCompetitionPoint, competition]
  );

  if (!showProjects) {
    return null;
  }

  if (openLikeTab) {
    return TabComponent;
  }

  return (
    <>
      <PopUpMenu
        key="menu-popup-deziiign"
        isVisible={visiblePopUp}
        onClose={() => setIsVisiblePopUp(false)}
        activeTab={selectedTab}
        showOnlyTabs
        banTabs={banMobileTabs}
      />
      <MainBlock style={{ marginTop: "64px" }}>
        <SmthBanner isHideMarginBottom isMobile={isMobile}>
          <ResizedImage files={competition?.titleImages} />
        </SmthBanner>
        <FlexBox align="center" offsetTop={40}>
          <ProjectsButchController
            //@ts-ignore
            filter={filterOpt}
            withoutRepost
            //onProjectsLoaded={setProjects}
            showCompetitionPoint={canViewCompetitionPoint}
            showCompetitionJuryPoint={isJury}
            currentCompetitionId={id}
            date={time}
            isInfinityNeed={false}
            externalPageParam
            competition={competition}
          />
        </FlexBox>
      </MainBlock>
    </>
  );
};
